// @TODO Fix the types here.
/* eslint-disable */
type Enum = { [s: number]: string | number };

export const getEnumValues = <T = Enum>(enumerable: Enum): T[] =>
  // @ts-ignore
  Object.keys(enumerable).map((key: any) => enumerable[key]);
